//#region src/starbucks_coupon_type.ts
var StarbucksCouponType = /* @__PURE__ */ function(StarbucksCouponType) {
	StarbucksCouponType["VillaAirportEmployee"] = "villa-airport-employee-discount-15%";
	return StarbucksCouponType;
}(StarbucksCouponType || {});
//#endregion
export { StarbucksCouponType };

//# sourceMappingURL=starbucks_coupon_type.js.map